module.exports = __webpack_public_path__ + "img/8.c5efebf5.jpg";